import * as R from 'ramda';

export const required = errorMessage => value =>
  value || value === 0 ? undefined : errorMessage;

export const pattern = (errorMessage, regExp) => value =>
  value && !regExp.test(value) ? errorMessage : undefined;

export const minValue = (errorMessage, min) => value =>
  value && +value < +min ? errorMessage : undefined;

export const maxValue = (errorMessage, max) => value =>
  value && +value > +max ? errorMessage : undefined;

export const maxLength = (errorMessage, max) => value =>
  value && value.length > max ? errorMessage : undefined;

export const minLength = (errorMessage, min) => value =>
  value && value.length < min ? errorMessage : undefined;

export const email = errorMessage => value =>
  pattern(
    errorMessage,
    /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&''*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
  )(value);

export const emails = (errorMessage, separator = ';') => value =>
  R.pipe(
    R.split(separator),
    R.map(
      R.pipe(
        R.trim,
        email(errorMessage),
      ),
    ),
    R.find(R.equals(errorMessage)),
  )(value || '');

export const internalVideo = value => value && /^.*\.mp4$/i.test(value);
